module.exports = {"320506001":"长桥街道","320506003":"越溪街道","320506004":"郭巷街道","320506005":"横泾街道","320506006":"香山街道","320506009":"城南街道","320506100":"甪直镇","320506103":"木渎镇","320506104":"胥口镇","320506107":"东山镇","320506108":"光福镇","320506109":"金庭镇","320506110":"临湖镇","320506400":"江苏省太湖采石公司","320506401":"吴中区林场","320506402":"西山农业园区","320506403":"穹窿山风景区","320506404":"开发区","320506405":"国家苏州太湖旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320506.json
// module id = 801
// module chunks = 0